import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import Users from './components/Users';
import PaymentsTable from './components/PaymentsTable';
import PixTable from './components/PixTable';
import SuportTable from './components/SuportTable';
import Login from './components/Login';
import 'sweetalert2/src/sweetalert2.scss';

const AppContent = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === '/';

  return (
    <>
      <CssBaseline />
      {!isLoginPage && <Sidebar />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/users" element={<Users />} />
        <Route path="/payments" element={<PaymentsTable />} />
        <Route path="/pix" element={<PixTable />} />
        <Route path="/support" element={<SuportTable />} /> 
      </Routes>
    </>
  );
};

const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
